import React from 'react';
import { GroupText } from 'app/components/group-text/group-text';
import { getExcelMappingText } from './helpers';
import { ExcelMappingsText } from './excel-mappings-text';
import { ExcelMappingsGroupField, ExcelMappingsItemProps } from '../types';
import { cellMaxLength, rangeMaxLength } from 'app/area/company-reports-administration/form/components/constants';
import styles from './excel-mappings-item.scss';

export const ExcelMappingsItem: React.FC<ExcelMappingsItemProps> = (props) => (
  <div className="row">
    <div className="col-md-12">
      <GroupText>{getExcelMappingText(props.value?.id, props.translation)}</GroupText>
      <div className={styles.container}>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ExcelMappingsText
              {...props}
              id={props.value?.id}
              field={ExcelMappingsGroupField.cell}
              value={props.value?.cell}
              text={props.translation.cell}
              maxLength={cellMaxLength}
              placeholder={props.translation.cell_placeholder} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <ExcelMappingsText
              {...props}
              id={props.value?.id}
              field={ExcelMappingsGroupField.range}
              value={props.value?.range}
              text={props.translation.range}
              maxLength={rangeMaxLength}
              infoText={{ visible: true, text: props.translation.range_info_text }} />
          </div>
        </div>
      </div>
    </div>
  </div>
);
